import { type MutationHookOptions, useMutation } from "@apollo/client";
import { DisconnectCCBillMutation } from "../graphql/mutations";
import type {
  DisconnectCcBillMutationType,
  DisconnectCcBillMutationVariablesType,
} from "@/types/graphql/partner.generated";

export const useDisconnectCCBillMutation = (
  options?: MutationHookOptions<
    DisconnectCcBillMutationType,
    DisconnectCcBillMutationVariablesType
  >
) => {
  return useMutation<
    DisconnectCcBillMutationType,
    DisconnectCcBillMutationVariablesType
  >(DisconnectCCBillMutation, options);
};
